import React, { PropTypes, Component } from 'react';
class Rating extends Component {
  static propTypes = {
    entities: PropTypes.object.isRequired
  }

  static defaultProps = {
    entities: {}
  }

  render() {
    if (!Object.keys(this.props.entities).length) {
      return null;
    }

    var entities = this.props.entities;
    if (null !== entities.rating) {
      var entity_rating = entities.rating;
      if (entity_rating.toString().split('.').length == 1) {
        var rating = entity_rating;
      } else {
        var i = entity_rating.toFixed(1);
        var k = i.split('.');
        var x = k[1];
        if (x[0] === 0) {
          var rating = parseFloat(Math.Floor(Number(i)));
        } else {
          if ((parseInt(k[1]) === 0) || (parseInt(k[1]) === 5)) {
            var rating = parseFloat(i);
          } else if ((k[1] > 0) && (k[1] <= 4)) {
            var l = 5;
            var rating = parseFloat(k[0] + '.' + l);
          } else if ((k[1] > 5) && (k[1] <= 9)) {
            var rating = parseFloat(Math.ceil(i));
          }
        }
      }
    } else {
      var rating = 0;
    }
    return (
      <div>
        { (rating === 5) && (
          <span className="rating">
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star"></i>
                                                          </span>
          ) }
        { (rating === 4) && (
          <span className="rating">
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star-empty icon-b icon-large"></i>
                                                          </span>
          ) }
        { (rating === 4.5) && (
          <span className="rating">
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star-half-empty icon-star"></i>
                                                          </span>
          ) }
        { (rating === 3) && (
          <span className="rating">
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star-empty icon-b icon-large"></i>
                                                              <i className="icon-star-empty icon-b icon-large"></i>
                                                          </span>
          ) }
        { (rating === 3.5) && (
          <span className="rating">
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star-half-empty icon-star"></i>
                                                              <i className="icon-star-empty icon-b icon-large"></i>
                                                          </span>
          ) }
        { (rating === 2) && (
          <span className="rating">
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star-empty icon-b icon-large"></i>
                                                              <i className="icon-star-empty icon-b icon-large"></i>
                                                              <i className="icon-star-empty icon-b icon-large"></i>
                                                          </span>
          ) }
        { (rating === 2.5) && (
          <span className="rating">
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star-half-empty icon-star"></i>
                                                              <i className="icon-star-empty icon-b icon-large"></i>
                                                              <i className="icon-star-empty icon-b icon-large"></i>
                                                          </span>
          ) }
        { (rating === 1) && (
          <span className="rating">
                                                                <i className="icon-star"></i>
                                                                <i className="icon-star-empty icon-large icon-b"></i>
                                                                <i className="icon-star-empty icon-large icon-b"></i>
                                                                <i className="icon-star-empty icon-large icon-b"></i>
                                                                <i className="icon-star-empty icon-large icon-b"></i>
                                                            </span>
          ) }
        { (rating === 1.5) && (
          <span className="rating">
                                                              <i className="icon-star"></i>
                                                              <i className="icon-star-half-empty icon-star"></i>
                                                              <i className="icon-star-empty icon-b icon-large"></i>
                                                              <i className="icon-star-empty icon-b icon-large"></i>
                                                              <i className="icon-star-empty icon-b icon-large"></i>
                                                          </span>
          ) }
        { (rating === 0) && (
          <span className="rating">
                                                                  <i className="icon-star-empty icon-b icon-large"></i>
                                                                  <i className="icon-star-empty icon-b icon-large"></i>
                                                                  <i className="icon-star-empty icon-b icon-large"></i>
                                                                  <i className="icon-star-empty icon-b icon-large"></i>
                                                                  <i className="icon-star-empty icon-b icon-large"></i>
                                                              </span>
          ) }
        { (rating === 0.5) && (
          <span className="rating">
                                                              <i className="icon-star-half-empty icon-star"></i>
                                                              <i className="icon-star-empty icon-b icon-large"></i>
                                                              <i className="icon-star-empty icon-b icon-large"></i>
                                                              <i className="icon-star-empty icon-b icon-large"></i>
                                                              <i className="icon-star-empty icon-b icon-large"></i>
                                                          </span>
          ) }
      </div>
      );
  }
}
module.exports = Rating;


// WEBPACK FOOTER //
// ./src/components/Rating.js